import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './index.scss';

// 姓名与头像共同标识用户，未设置头像或加载失败时使用默认用户图标。
const UserIdentity = ({ user, size = 24, showUid = false, fallback = '用户' }) => {
  const name = user?.nickname || user?.username || fallback;
  return <span className="userIdentity">
    <Avatar size={size} src={user?.avatar || undefined} alt={`${name}的头像`} icon={<UserOutlined />} />
    <span className="userIdentity-name">{name}{showUid && user?.id != null && ` · UID ${user.id}`}</span>
  </span>;
};

export default UserIdentity;
